import React, { useEffect, useState, Fragment } from 'react';

import ContentParser from 'src/ui/library/ContentParser';
import Spinner from 'src/ui/library/Spinner/Spinner';
import ReviewAndSubmitContainer from '../Container/ReviewAndSubmitContainer';
import QuestionnaireSalaryPres from '../Presentation/QuestionnaireSalaryPres';
import {
  QuestionnaireProfileList,
  QuestionnaireProfileDetails,
  QuestionnaireProfileDelete,
  upsertRelatedRecord,
} from 'src/services/accounts.service';
import { refreshQuestionnaire } from 'src/services/questionnaire.service.js';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import intl from 'react-intl-universal';
import Button from 'src/ui/library/Button';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import { Edit, Delete } from '@material-ui/icons';
import { TableLanding } from 'src/ui/library/Table/extensions';
import { transformFormValues } from 'src/helpers';
import ButtonComponent from 'src/new-ui/library/ButtonComponent';
import saveIcon from '../../../../assets/dashboardIcons/saveIcon.png';
// import save_24px from '../../../../assets/dashboardIcons/save_24px.svg';
import chevronLeft from '../../../../assets/dashboardIcons/chevron_left.png';
import Grid from '@material-ui/core/Grid';
import chevron_rightIcon from 'src/assets/chevron_right.svg';
//import ListIcon from '@material-ui/icons/List';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment';
import { toMoment } from 'src/helpers/date';
import WarningIcon from '@material-ui/icons/Warning';
import { fnGetCaseRelatedId, fnIsDefaultOldView, fnResetPageState } from 'src/helpers/commonFunctions';

export const QuestionnairePagePres = ({
  introData,
  pageData,
  push,
  isMobile,
  isTablet,
  match,
  setValidationFn,
  setFormValues,
  formValues,
  handleSave,
  onSaveExit,
  gotoPage,
  onMenuExpand,
  isLoading,
  curExpandedMenu,
  isSaveLoading,
  updatedPage,
  parentMenuTypeCode,
  handlePage,
  isFirstPage,
  isReviewEnabled,
  isPageLoaded,
  handleSaveProgress,
  setPageLoading,
  setCheckboxChecked,
  isCheckboxChecked,
  isCheckboxUpdated,
  setCheckboxUpdated,
  getAdditionalPropsForRelatedEntities,
  rows,
  clientLookup,
  isLastPage,
  caseHeaderDetails,
  ...props
}) => {
  const [entityRows, setEntityRows] = useState([]);
  const [entityColumns, setEntityColumns] = useState([]);
  const menus = pageData.menus || [];
  const [showDialog, setShowDialog] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [readOnly, setReadOnly] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRefreshConfirmModal, setShowRefreshConfirmModal] = useState(false);
  const [isRefreshLoading, setIsRefreshLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [rowClickData, setRowClickData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(true);
  const [rowEntityId, setRowEntityId] = useState();
  const [refreshTable, setRefreshTable] = useState(false);
  const [searchTxt, setSearchTxt] = useState();
  const [sortCol, setSortCol] = useState();
  const [sorting, setSorting] = useState('asc');
  const [pageNo, setPageNo] = useState(1);
  const [hasSalaryModel, setHasSalaryModel] = useState(false);
  const [salaryPageData, SetSalaryPageData] = useState();
  const [avoidRender, setAvoidRender] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [isValidStartDate, setIsValidStartDate] = useState(false);
  const [saveNotDone, setSaveNotDone] = useState(false);
  const [deleteNotDone, setDeleteNotDone] = useState(false);
  const pageId = fnGetCaseRelatedId(4);
  useEffect(() => {
    setPageLoading(false);
    if (pageData && pageData.entityLogicalName === 'ey_employmentprofileversion' && hasSalaryModel) {
      QuestionnaireProfileDetails({
        entityName: 'ey_employmentsalaryprofileversion',
        entityId: '00000000-0000-0000-0000-000000000000',
        questionaireId: pageData.entityId,
        pageId: pageData.pageId,
      }).then(response => {
        if (response != null) {
          SetSalaryPageData(response);
        }
      });
    }
    if (isLoaded === false)
      QuestionnaireProfileDetails({
        entityName: pageData.entityLogicalName,
        entityId: rowEntityId,
        questionaireId: pageData.entityId,
        pageId: pageData.pageId,
      }).then(response => {
        if (response != null && response.pageElements) {
          response.pageElements = response.pageElements.filter(
            x =>
              x.controlTypeName.toLowerCase() !== 'caption' &&
              ((x.controlTypeName.toLowerCase() === 'header' && x.value === '') || x.controlTypeName.toLowerCase() !== 'header'),
          );
          setRowClickData(response);
          setIsLoaded(true);
        }
      });
    if (refreshTable === true) {
      QuestionnaireProfileList({
        pageNumber: pageNo,
        searchText: searchTxt,
        entitySetName: 'questionaire',
        entityId: pageData.entityId,
        entityLogicalName: pageData.entityLogicalName,
        pageSize: 15,
        sortDirection: sorting,
        sortColumn: sortCol,
        pageId: pageData.pageId ? pageData.pageId : null,
      }).then(response => {
        if (response && response.rows) {
          const rdata = response.rows.map((row, index) => ({ ...row, index }));

          rdata && setEntityRows(rdata);
        }

        if (response && response.columns) {
          setEntityColumns(response.columns);
        }
        setRefreshTable(false);
      });
    }
    //getAdditionalPropsForRelatedEntities(pageData.entityLogicalName);
    setPageLoading(true);
  }, [pageData.entityId, isLoaded, refreshTable, rowEntityId, searchTxt, hasSalaryModel]);

  useEffect(() => {
    if (isLastPage) {
      let counter = 0;
      let timer = setInterval(() => {
        counter++;
        if (!isLastPage || counter > 10) {
          clearInterval(timer);
          timer = 0;
        } else {
          if (sessionStorage.getItem('page_reset') === 'true') {
            setIsEnabled(true);
            sessionStorage.removeItem('page_reset');
            clearInterval(timer);
          }
        }
      }, 1000);
    } else {
      setIsEnabled(false);
    }
  }, [pageData]);

  const handleOnClick = () => {
    setHasSalaryModel(false);
    setIsCreate(true);
    setReadOnly(false);

    setShowDialog(true);
  };
  const cancelshowViewDialog = () => {
    setShowDialog(false);
    setIsCreate(false);
    setReadOnly(true);
    setHasSalaryModel(false);
    setDeleteNotDone(false);
    setSaveNotDone(false);
  };
  const onCancelDialog = () => {
    setIsCreate(false);
    setReadOnly(true);
    setShowDialog(false);
    setDeleteNotDone(false);
    setSaveNotDone(false);
  };
  const onEdit = () => {
    setIsLoaded(false);
    setReadOnly(false);
  };
  const onDelete = () => {
    setDeleteNotDone(true);
    setShowDeleteModal(true);
  };
  const onCancelDeleteModal = () => {
    setShowDeleteModal(false);
    setReadOnly(true);
    setDeleteNotDone(false);
  };

  const getQuestionnaireTableList = () => {
    setIsLoaded(false);
    QuestionnaireProfileList({
      pageNumber: pageNo,
      searchText: searchTxt,
      entitySetName: 'questionaire',
      entityId: pageData.entityId,
      entityLogicalName: pageData.entityLogicalName,
      pageSize: 15,
      sortDirection: sorting,
      sortColumn: sortCol,
      pageId: pageData.pageId ? pageData.pageId : null,
    }).then(response => {
      if (response && response.rows) {
        const rdata = response.rows.map((row, index) => ({ ...row, index }));
        rdata && setEntityRows(rdata);
      }
      if (response && response.columns) {
        setEntityColumns(response.columns);
      }
      setIsRefreshLoading(false);
      setIsLoaded(true);
    });
  };

  const onConfirmRefreshModal = async () => {
    setSaveNotDone(false);
    setDeleteNotDone(false);
    setShowRefreshConfirmModal(false);
    const { entityId: questionaireId, pageId } = pageData;
    const menuObj = fnResetPageState(props.caseDatacollectMenu.menuDetails, questionaireId, pageId);
    props.setCaseDetail(menuObj, true);
    props.setRefreshPageStatus(false);

    if (questionaireId !== '00000000-0000-0000-0000-000000000000' && pageId !== '00000000-0000-0000-0000-000000000000') {
      setIsRefreshLoading(true);
      await refreshQuestionnaire(questionaireId, pageId).then(
        // res => {
        //   props.setCaseSubmitted(true);
        //   setCheckboxChecked(false);
        //   getQuestionnaireTableList();
        // },
        res => {
          if (res && res.length > 10) {
            props.setCaseSubmitted(true);

            getQuestionnaireTableList();
          } else {
            setIsRefreshLoading(false);
            props.setCaseSubmitted(true);
            pageData.notApplicable = false;
            pageData.unSure = false;
          }
        },
        error => {
          props.enqueueSnackbar('Error: ' + error.message, {
            variant: 'error',
          });
          setIsRefreshLoading(false);
        },
      );
    }
  };
  const onCancelRefreshModal = () => {
    setShowRefreshConfirmModal(false);
  };
  const onCancelEditModal = () => {
    setShowEditModal(false);
    setReadOnly(true);
    setSaveNotDone(false);
  };
  const onConfirmEditModal = () => {
    setReadOnly(false);
    setShowEditModal(false);
  };
  const onConfirmDeleteModal = async () => {
    setShowDeleteModal(false);
    setDeleteNotDone(true);
    try {
      await QuestionnaireProfileDelete({
        entityName: pageData.entityLogicalName,
        entityId: rowEntityId,
        pageId: pageData.pageId ? pageData.pageId : null,
        questionnaireId: pageData.entityId ? pageData.entityId : null,
      });
    } finally {
      if (
        entityRows.filter(x => x[1].toLowerCase() === 'yes').length === 1 &&
        entityRows.filter(x => x[0] === rowEntityId && x[1].toLowerCase() === 'yes').length === 1
      )
        props.setCaseSubmitted(true);
    }
    setShowDialog(false);
    setRefreshTable(true);
    setDeleteNotDone(false);
  };
  const onSave = async () => {
    setReadOnly(true);
    setSaveNotDone(true);
    if (pageData && pageData.entityLogicalName !== 'ey_employmentprofileversion') {
      setShowDialog(false);
    }
    const data = {
      topLevelRecordId: pageData.entityId,
      entityLogicalName: pageData.entityLogicalName,
      relationshipName: '',
      parentId: pageData.entityId,
      parentEntityName: 'ey_immigrationquestionnaire',
      entityId: isCreate ? '00000000-0000-0000-0000-000000000000' : rowEntityId,
      pageId: pageData.pageId ? pageData.pageId : null,
      ...transformFormValues(formValues.formValues),
    };

    await upsertRelatedRecord(data).then(
      result => {
        result && setRowEntityId(result.entityId);
        result && setRowClickData(result);
        if (pageData && pageData.entityLogicalName === 'ey_employmentprofileversion') {
          setHasSalaryModel(true);
          setIsLoaded(false);
        } else {
          setIsLoaded(true);
        }
        setIsCreate(false);
        setRefreshTable(true);
        setSaveNotDone(false);
      },
      error => {},
    );
  };

  const getNumCols = () => {
    if (isTablet || isMobile) {
      return 1;
    }

    let numCols = 3;
    menus.forEach(m => {
      m.subMenu.forEach(sm => {
        if (sm.pageId === pageData.pageId && sm.numColumns) {
          numCols = sm.numColumns;
        }
      });
    });

    return numCols;
  };
  const handleActionMenu = (data, hideMenuFn) => {
    setAvoidRender(true);
    const {
      model: { rows },
      rowClicked: { origRowIndex },
    } = data;
    const row = rows[origRowIndex];
    var recordId;
    row.forEach(column => {
      if (column.columnId === 'id') {
        recordId = column.value;
      }
    });

    return (
      avoidRender && (
        <Fragment>
          {/* <li key="view details">
            <a
              aria-label="View Details for Row"
              tabIndex={0}
              onClick={() => {
                setShowDialog(true);
                setAvoidRender(true);
                setRowEntityId(recordId);
                setIsLoaded(false);
                hideMenuFn(false);
              }}>
              <ListIcon />
              <span className="action-item-text">{intl.get('table.labels.viewDetails')}</span>
            </a>
          </li> */}
          <li key="delete">
            <a
              aria-label="Delete Row"
              tabIndex={0}
              onClick={() => {
                setRowEntityId(recordId);
                setShowDeleteModal(true);
                hideMenuFn(false);
              }}>
              <DeleteIcon />
              <span className="action-item-text">{intl.get('table.labels.delete')}</span>
            </a>
          </li>
        </Fragment>
      )
    );
  };

  const onTableChange = (actionType, data, ...otherData) => {
    switch (actionType) {
      case 'cellClick':
        const rowIndex = data.cellClicked.rowIndex;
        const row = data.model.rows[rowIndex];
        row.forEach(column => {
          if (column.columnId === 'id') {
            setRowEntityId(column.value);
            setIsLoaded(false);
            setHasSalaryModel(true);
            setShowDialog(true);
          }
        });
        break;
      default:
        return undefined;
    }
  };

  const filterPageData = (pageData, showHeaders, isMultiline, caseDetails) => {
    const page = { ...pageData };
    if (isMultiline) {
      page.pageElements = showHeaders
        ? pageData.pageElements.filter(
            x =>
              x.controlTypeName.toLowerCase() === 'caption' ||
              (x.controlTypeName.toLowerCase() === 'header' && (x.value === null || x.value === ' ')),
          )
        : pageData.pageElements.filter(
            x =>
              x.controlTypeName.toLowerCase() !== 'caption' &&
              ((x.controlTypeName.toLowerCase() === 'header' && x.value === '') || x.controlTypeName.toLowerCase() !== 'header'),
          );
    }
    let submenu = caseDetails && caseDetails.serviceCountry.toLowerCase();
    let filteredRows = rows.filter(ele => ele.countryName.valueOf().toLowerCase() === submenu);
    let RemainingRows = rows.filter(ele => ele.countryName.valueOf().toLowerCase() !== submenu);
    let OrderedRows = [...filteredRows, ...RemainingRows];
    if (showHeaders) {
      page.pageElements = page.pageElements.map(x => {
        x.value = x.value ? x.value : ' ';
        return x;
      });
    }
    return {
      ...page,
      lookUps: {
        ...pageData.lookUps,
        ey_hostcompanyid: OrderedRows,
        ey_thirdparty: clientLookup,
      },
    };
  };
  const onValidate = (fields, setErrorFn) => {
    setValidationError(false);
    setIsValidStartDate(false);
    const {
      ey_travelstartdate,
      ey_travelenddate,
      ey_startdate,
      ey_enddate,
      ey_effectiveenddate,
      ey_effectivestartdate,
      ey_issuedate,
      ey_birthdate,
    } = fields;
    const setErrorDate =
      (ey_enddate && 'ey_enddate') || (ey_effectiveenddate && 'ey_effectiveenddate') || (ey_travelenddate && 'ey_travelenddate');

    if (ey_travelstartdate && ey_travelstartdate.length === 11 && pageData && pageData.isUpcomingTravelPage) {
      let s = moment(ey_travelstartdate, 'DD-MMM-YYYY').format('YYYYMMDD');
      if (moment(s).diff(moment(), 'days') < 0) {
        const errorMsg = (
          <span className="error-msg">
            <WarningIcon />
            <b>{intl.get(`employees.refreshMessage.startDateErrorMessage`)}</b>
          </span>
        );
        setErrorFn('ey_travelstartdate', true, errorMsg);
        setIsValidStartDate(true);
      } else {
        setErrorFn('ey_travelstartdate', false, null);
        setIsValidStartDate(false);
      }
    } else {
      setErrorFn('ey_travelstartdate', false, null);
      setIsValidStartDate(false);
    }

    if (
      (ey_travelstartdate && ey_travelenddate) ||
      ((ey_startdate || ey_issuedate) && ey_enddate) ||
      (ey_effectivestartdate && ey_effectiveenddate)
    ) {
      let genericStartDate;
      let genericEndDate;
      genericStartDate = ey_travelstartdate
        ? ey_travelstartdate
        : ey_startdate
        ? ey_startdate
        : ey_effectivestartdate
        ? ey_effectivestartdate
        : ey_issuedate;
      genericEndDate = ey_travelenddate ? ey_travelenddate : ey_enddate ? ey_enddate : ey_effectiveenddate;
      if (genericStartDate && genericEndDate) {
        if (toMoment(genericEndDate) < toMoment(genericStartDate)) {
          const errorMsg = (
            <span className="error-msg">
              <WarningIcon />
              <b>End date cannot occur before Start date</b>
            </span>
          );
          setErrorFn(setErrorDate, true, errorMsg);
          setValidationError(true);
        } else {
          setErrorFn(setErrorDate, false, null);
          setValidationError(false);
        }
      }
    } else {
      setErrorFn(setErrorDate, false, null);
      setValidationError(false);
    }

    if (ey_birthdate) {
      if (
        ey_birthdate !== '' &&
        moment()
          .startOf('day')
          .diff(moment(ey_birthdate), 'days') < 0
      ) {
        const errorMsgBirthdate = (
          <span className="error-msg">
            <WarningIcon />
            <b>{intl.get(`employees.refreshMessage.birthdateMessage`)}</b>
          </span>
        );
        setErrorFn('ey_birthdate', true, errorMsgBirthdate);
        setValidationError(true);
      } else {
        setErrorFn('ey_birthdate', false, null);
        setValidationError(false);
      }
    }
  };
  //const currentMenuName = get(match, 'params.sectionName');
  var isMultiline = pageData && pageData.isMultiline;
  var isSubmitted = pageData.isSubmitted;
  let subMenu =
    pageData &&
    pageData.menus &&
    pageData.menus.length > 0 &&
    pageData.menus[0].subMenu.length > 0 &&
    pageData.menus[0].subMenu.filter(content => content.pageId === pageData.pageId).map(submenu => submenu.menuName);
  let menuTypeCode = 0;
  if (props.caseDatacollectMenu && props.caseDatacollectMenu.menuDetails) {
    let menuCode = props.caseDatacollectMenu.menuDetails
      .filter(eachmenu => eachmenu.pageId === pageData.entityId)
      .map(menudetail => menudetail.menuTypeCode);
    menuTypeCode = menuCode.length > 0 ? menuCode[0] : null; //random number
  }
  return (
    <React.Fragment>
      {isRefreshLoading ? (
        <div className="questionnaire-spinner">
          <Spinner size={70} />
        </div>
      ) : (
        <div>
          {!isLoading &&
          menuTypeCode === 1 &&
          props.location.pathname &&
          props.location.pathname.split('/')[4] !== '00000000-0000-0000-0000-000000000000' &&
          props.location.pathname.split('/')[3] !== '00000000-0000-0000-0000-000000000000' &&
          isPageLoaded ? (
            <div>
              {isMultiline ? (
                <div className="container-height">
                  {showRefreshConfirmModal && (
                    <div className="content">
                      <ConfirmDialog
                        open
                        title={intl.get(`employees.refreshMessage.refreshDialogTitle`)}
                        cancelText={intl.get(`employees.refreshMessage.cancel`)}
                        confirmText={intl.get(`employees.refreshMessage.confirm`)}
                        onCancel={onCancelRefreshModal}
                        onConfirm={onConfirmRefreshModal}>
                        {intl.get(`employees.refreshMessage.refreshDialogMessage`)} <br />
                        {intl.get(`employees.refreshMessage.refreshDialogNote`)}
                      </ConfirmDialog>
                    </div>
                  )}
                  {showEditModal && (
                    <ConfirmDialog
                      open
                      title={intl.get(`${'profile'}.details.confirmDialogTitle`)}
                      cancelText={intl.get(`${'profile'}.details.buttons.cancelEdit`)}
                      confirmText={intl.get(`${'profile'}.details.buttons.continueEdit`)}
                      onCancel={onCancelEditModal}
                      onConfirm={onConfirmEditModal}>
                      {intl.get(`${'profile'}.details.cancelEditDialogMessage`)}
                    </ConfirmDialog>
                  )}
                  {showDeleteModal && (
                    <ConfirmDialog
                      open
                      title={intl.get(`${'profile'}.details.confirmDialogTitle`)}
                      cancelText={intl.get(`${'profile'}.details.buttons.cancel`)}
                      confirmText={intl.get(`${'profile'}.details.buttons.confirm`)}
                      onCancel={onCancelDeleteModal}
                      onConfirm={onConfirmDeleteModal}>
                      {intl.get(`${'profile'}.details.deleteRecordDialogMessage`)}
                    </ConfirmDialog>
                  )}
                  {showDialog && (
                    <Dialog
                      open
                      aria-labelledby="dialog-title"
                      fullWidth
                      maxWidth="md"
                      className={fnIsDefaultOldView() ? 'largemodal' : 'largemodal add-details-modal modal-details'}>
                      <DialogTitle id="dialog-title">
                        {subMenu}
                        <IconButton aria-label="close" onClick={cancelshowViewDialog} className="close-button">
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent>
                        <div className="content">
                          {isLoaded && !saveNotDone ? (
                            <ContentParser
                              readOnly={!isCreate && readOnly}
                              key={pageData.pageId}
                              pageId={pageData.pageId}
                              data={isCreate ? filterPageData(pageData, false, true) : rowClickData}
                              onChange={setFormValues}
                              showLabels={false}
                              numberOfColumns={'3'}
                              forceNumberOfColumns={isMobile || isTablet}
                              debug={false}
                              fnValidateForm={setValidationFn}
                              onValidate={onValidate}
                            />
                          ) : (
                            <div style={{ marginTop: '10%', marginBottom: '10%' }}>
                              <Spinner size={50} />
                            </div>
                          )}
                          {pageData && pageData.entityLogicalName === 'ey_employmentprofileversion' && hasSalaryModel && salaryPageData && (
                            <Grid container>
                              <Grid item md={12}>
                                <h3>Employment Salary </h3>
                                <hr />
                                <QuestionnaireSalaryPres
                                  history={props.history}
                                  pageData={salaryPageData}
                                  match={match}
                                  formValues={formValues}
                                  employmentId={pageData.entityId}
                                  rowId={rowEntityId}
                                  isSubmitted={isSubmitted}
                                  {...props}
                                />
                              </Grid>
                            </Grid>
                          )}
                        </div>
                      </DialogContent>
                      <DialogActions>
                        <section className="actions">
                          {!readOnly ? (
                            <div className="save-cancel-wrapper">
                              <Button styleType="secondary" onClick={onCancelDialog} className="action-button">
                                {intl.get(`${'profile'}.details.buttons.cancel`)}
                              </Button>
                              <Button
                                className="action-button"
                                disabled={!formValues.isFormComplete || !isLoaded || validationError || isValidStartDate}
                                onClick={onSave}>
                                {intl.get(`${'profile'}.details.buttons.save`)}
                              </Button>
                            </div>
                          ) : (
                            <Fragment>
                              {!isSubmitted && (
                                <div className="edit-delete-wrapper">
                                  <a className="link" onClick={onEdit}>
                                    <Edit className="icon" /> <span className="text">{intl.get(`${'profile'}.details.buttons.edit`)}</span>
                                  </a>
                                  {pageData && pageData.entityLogicalName === 'ey_employmentprofileversion' && (
                                    <a className="link" onClick={onDelete}>
                                      <Delete className="icon" />{' '}
                                      <span className="text">{intl.get(`${'profile'}.details.buttons.delete`)}</span>
                                    </a>
                                  )}
                                </div>
                              )}
                              {!isSubmitted && (
                                <div className="edit-delete-wrapper right-end">
                                  {pageData && pageData.entityLogicalName === 'ey_employmentprofileversion' ? (
                                    <Button className="action-button" onClick={cancelshowViewDialog}>
                                      {intl.get(`${'profile'}.details.buttons.save`)}
                                    </Button>
                                  ) : (
                                    <a className="link" onClick={onDelete}>
                                      <Delete className="icon" />{' '}
                                      <span className="text">{intl.get(`${'profile'}.details.buttons.delete`)}</span>
                                    </a>
                                  )}
                                </div>
                              )}
                            </Fragment>
                          )}
                        </section>
                      </DialogActions>
                    </Dialog>
                  )}
                  {
                    <ContentParser
                      readOnly={true}
                      key={pageData.pageId}
                      pageId={pageData.pageId}
                      data={filterPageData(pageData, true, true)}
                      onChange={setFormValues}
                      showLabels={false}
                      numberOfColumns={'1'}
                      forceNumberOfColumns={isMobile || isTablet}
                      debug={false}
                      fnValidateForm={setValidationFn}
                    />
                  }
                  {!saveNotDone && !deleteNotDone && pageId === pageData.pageId ? (
                    <TableLanding
                      history={props.history}
                      rowsPerPage={15}
                      actionable={true}
                      sortDirection={'asc'}
                      columns={entityColumns}
                      rows={entityRows}
                      pageData={pageData}
                      setCheckboxChecked={setCheckboxChecked}
                      setCheckboxUpdated={setCheckboxUpdated}
                      gridFilter={{
                        hideFilterButton: true,
                        // filters: response => {getGridFilters(response)},
                        render: TableFilter => (
                          <div className="landing-gridfilter-container">
                            {TableFilter}
                            <Button styleType="primary" disabled={isSubmitted} onClick={!isSubmitted && handleOnClick}>
                              <span>{intl.get('table.labels.addButton')}</span>
                            </Button>
                            <div className="subject-btn">
                              {isLoaded && (
                                <Button
                                  styleType="primary"
                                  className="primary-btn"
                                  disabled={isSubmitted || isRefreshLoading}
                                  onClick={() => setShowRefreshConfirmModal(true)}>
                                  <img
                                    src={require('../../../../assets/dashboardIcons/Vector.svg')}
                                    alt=""
                                    style={{ paddingRight: '8px' }}
                                  />
                                  <span>{intl.get(`employees.refreshMessage.refreshButton`)}</span>
                                </Button>
                              )}
                            </div>
                          </div>
                        ),
                      }}
                      pagination={true}
                      hideLandingHeader={true}
                      selectableRows={true}
                      onRequestData={async (params, config) =>
                        await QuestionnaireProfileList(
                          {
                            ...params,
                            entitySetName: 'questionaire',
                            entityId: pageData.entityId,
                            entityLogicalName: pageData.entityLogicalName,
                            searchText: params.searchText,
                            sortDirection: sorting,
                            sortColumn: sortCol,
                            pageId: pageData.pageId ? pageData.pageId : null,
                          },
                          config,
                          setSearchTxt(params.searchText),
                          setPageNo(params.pageNumber),
                          setSorting(params.sortDirection),
                          setSortCol(params.sortColumn),
                        ).then(response => {
                          if (response && response.rows) {
                            const rdata = response.rows.map((row, index) => ({ ...row, index }));

                            rdata && setEntityRows(rdata);
                          }

                          if (response && response.columns) {
                            setEntityColumns(response.columns);
                          }
                          return response;
                        })
                      }
                      onTableChange={onTableChange}
                      actionableRender={pageData && handleActionMenu}
                      showCheckbox={true}
                      isPageMandatory={pageData.isMandatory}
                    />
                  ) : (
                    <div className="questionnaire-spinner">
                      <Spinner size={70} />
                    </div>
                  )}
                </div>
              ) : (
                <div className="content-parser-container">
                  {isLoading || !pageData.pageId ? (
                    <div className="questionnaire-spinner">
                      <Spinner size={70} />
                    </div>
                  ) : (
                    <ContentParser
                      key={pageData.pageId}
                      pageId={pageData.pageId}
                      data={filterPageData(pageData, false, false, caseHeaderDetails)}
                      onChange={setFormValues}
                      showLabels={false}
                      numberOfColumns={getNumCols()}
                      forceNumberOfColumns={isMobile || isTablet}
                      debug={false}
                      fnValidateForm={setValidationFn}
                    />
                  )}
                </div>
              )}
              {!isLoading && (
                <div className="questionBtns">
                  {!isMultiline && !isSubmitted && (
                    <ButtonComponent
                      text="Save progress"
                      imgLeft={saveIcon}
                      onClick={() => handleSaveProgress()}
                      disabled={isSaveLoading}
                      className="secondary save-progress"></ButtonComponent>
                  )}
                  {!isFirstPage && (
                    <ButtonComponent
                      text="Back "
                      disabled={isSaveLoading || (isMultiline ? !isCheckboxChecked : !formValues.isFormComplete)}
                      onClick={() => handlePage(false)}
                      imgLeft={chevronLeft}
                      className="secondary"></ButtonComponent>
                  )}
                  {(!isReviewEnabled || isEnabled) && (
                    <ButtonComponent
                      text="Next "
                      disabled={isSaveLoading || (isMultiline ? !isCheckboxChecked : !formValues.isFormComplete)}
                      onClick={() => handlePage(true)}
                      imgRight={chevron_rightIcon}></ButtonComponent>
                  )}
                </div>
              )}
            </div>
          ) : (
            <React.Fragment>
              {props.location.pathname && props.location.pathname.split('/')[4] === '00000000-0000-0000-0000-000000000000' && (
                <ReviewAndSubmitContainer {...props} />
              )}
              {props.location.pathname && props.location.pathname.split('/')[4] !== '00000000-0000-0000-0000-000000000000' && (
                <div className="questionnaire-spinner">
                  <Spinner size={70} />
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default QuestionnairePagePres;
